<mat-card class="all-grades-card" *ngIf="blockData">
    <app-card-header [title]="blockData.title" [icon]="blockData.icon" />
  
    <mat-card-content>
      <app-all-grades [data]="blockData" [generalSettings]="generalSettingsData"/>
    </mat-card-content>
  </mat-card>
